import { useCallback } from 'react';
import { trackLinkOut, BaseEventData } from '../../features/gtmTracking';
import { botIdSelector, pageFullUrlSelector, websiteLocationSelector } from '../../features/chatbotSlice';
import { getUtmParameters } from '../../features/chatbotUtil';
import { useAppSelector } from '../hooks';

export const useLinkHandler = () => {
  const botId = useAppSelector(botIdSelector);
  const websiteLocation = useAppSelector(websiteLocationSelector);
  const pageFullUrl = useAppSelector(pageFullUrlSelector);

  const getBaseData = useCallback((): BaseEventData => {
    return {
      botId: botId || '',
      pageUrl: pageFullUrl || window.location.href,
      timestamp: Date.now(),
      ...getUtmParameters()
    };
  }, [botId, pageFullUrl]);

  const openLink = useCallback((href: string | undefined, isNewWindow: boolean = true, e?: any) => {
    if (e) {
      e.preventDefault();
    }

    if (!href) {
      return;
    }

    trackLinkOut(getBaseData(), href, websiteLocation);

    if (websiteLocation) {
      window.parent.postMessage(
        {
          type: 'open-link',
          href: href,
          inNew: isNewWindow,
        },
        websiteLocation
      );
    }
  }, [getBaseData, websiteLocation]);

  return { openLink };
};
